// Mock data for CasinoPicks replica (frontend-only)

export const CASINOS = [
  {
    rank: 1,
    slug: "betnjet",
    name: "BetNJet",
    rating: 4.9,
    logo: "https://casinopick.online/__l5e/assets-v1/791fb3de-6097-4ee3-a79b-5f4d02b58144/betnjet.jpg",
    playUrl: "https://www.betnjet.com/",
    kind: "Sportsbook & casino",
    offer:
      "New customer offer on first qualifying bet or deposit — see the current terms on site",
    intro:
      "BetNJet is one of the newer names on the UK betting scene, and it competes on speed rather than size: a lean interface, quick bet placement and withdrawals that clear faster than most of the established books. It has less history behind it than the veterans, which is the trade-off.",
    quickFacts: [
      { label: "Founded", value: "Recent UK-facing launch" },
      { label: "Available regions", value: "United Kingdom" },
      { label: "Minimum redemption", value: "Withdrawals from £10 after verification" },
      { label: "Game providers", value: "4+ studios" },
    ],
    overview: [
      "The product is a combined sportsbook and casino under one wallet. Football dominates the betting menu, as it should for a UK book, with horse racing, tennis, darts, snooker, cricket and NFL filling out the rest.",
      "What stands out is the interface. There is very little clutter — no wall of promotional banners between you and the bet slip — which makes it noticeably quicker to place a bet on a phone during a live match.",
      "As a newer brand it does not yet match the biggest books on market depth, streaming rights or long-term promotions. Judge it on execution rather than breadth.",
    ],
    pros: [
      "Fast, uncluttered interface that makes in-play betting quicker on mobile",
      "Withdrawals process faster than most established UK books",
      "Single wallet across sportsbook and casino",
      "Strong football coverage including accumulator and player markets",
      "Debit card, Apple Pay and open banking deposits all supported",
      "Clear, plain-English bonus terms with the qualifying conditions upfront",
    ],
    cons: [
      "Short trading history compared with the established books",
      "No live streaming library to speak of",
      "Market depth on niche sports is thinner than at the major books",
      "Ongoing promotions for existing customers are limited",
    ],
    keyFacts: [
      { label: "Launch year", value: "Recent UK-facing launch" },
      { label: "Availability", value: "United Kingdom; 18+ only" },
      { label: "Minimum purchase", value: "Minimum deposit typically £10" },
      { label: "Redemption", value: "Withdrawals from £10 after verification" },
      { label: "Payment methods", value: "Debit card, Apple Pay, open banking, e-wallets" },
      { label: "Mobile", value: "Mobile-first website" },
      { label: "Customer support", value: "Live chat and email" },
      { label: "Crypto support", value: "Not supported — UK operators settle in GBP" },
    ],
    games: [
      "Football: match odds, over/under, both teams to score, bet builder and player props.",
      "Horse racing with UK and Irish meetings priced daily.",
      "Tennis, darts, snooker, cricket, rugby, NFL and NBA.",
      "Casino section with slots, live dealer tables and RNG table games.",
    ],
    providers: ["Pragmatic Play", "Play'n GO", "Evolution", "Hacksaw Gaming"],
    verdict:
      "BetNJet is the sharpest-feeling product on our UK list. The interface is fast, the bet slip is excellent and the withdrawals do not drag — the three things that actually affect a betting session. It ranks first on execution.",
  },
  {
    rank: 2,
    slug: "bet365",
    name: "Bet365",
    rating: 4.7,
    logo: "https://casinopick.online/__l5e/assets-v1/4dbdc9a7-0325-497b-a0a9-d0bc482f738b/bet365.webp",
    playUrl: "https://www.bet365.com/",
    kind: "Sportsbook & casino",
    offer:
      "New customer offer in bet credits or a first-bet promotion — terms on site",
    intro:
      "Bet365 is the benchmark the rest of the market is measured against. Its scale shows in the depth of markets, the reliability of in-play pricing and one of the largest live streaming libraries in betting. It is not the flashiest product, but it is the most complete.",
    quickFacts: [
      { label: "Founded", value: "2000" },
      { label: "Available regions", value: "United Kingdom and many international markets" },
      { label: "Minimum redemption", value: "Withdrawals from £5 after verification" },
      { label: "Game providers", value: "20+ studios" },
    ],
    overview: [
      "Bet365 runs a combined sportsbook and casino with a single wallet. The sportsbook is the headline act: enormous market depth, fast in-play settlement and a streaming service that covers thousands of events a year.",
      "The casino, poker and games sections are all fully featured, with a broad slots catalogue and a large live dealer offering.",
      "The interface is dense rather than minimal — it packs a lot on screen — which suits experienced bettors more than newcomers.",
    ],
    pros: [
      "Market-leading depth of sports and betting markets",
      "One of the largest live streaming libraries in the industry",
      "Reliable in-play pricing and fast settlement",
      "Single wallet across sportsbook, casino, poker and games",
      "Strong cash-out and bet builder tools",
      "Well-established, heavily regulated operator",
    ],
    cons: [
      "Interface can feel cluttered for new users",
      "Promotions are less generous than some challengers",
      "Account restrictions can apply to consistent winners",
      "Casino bonuses come with standard wagering requirements",
    ],
    keyFacts: [
      { label: "Launch year", value: "2000" },
      { label: "Availability", value: "United Kingdom and international; 18+ only" },
      { label: "Minimum purchase", value: "Minimum deposit typically £5" },
      { label: "Redemption", value: "Withdrawals from £5 after verification" },
      { label: "Payment methods", value: "Debit card, PayPal, Apple Pay, bank transfer" },
      { label: "Mobile", value: "Native iOS and Android apps plus mobile web" },
      { label: "Customer support", value: "24/7 live chat, phone and email" },
      { label: "Crypto support", value: "Not supported" },
    ],
    games: [
      "Football, horse racing, tennis, basketball, American sports and dozens more.",
      "Extensive in-play markets with live streaming for many events.",
      "Casino slots, live dealer tables, roulette and blackjack.",
      "Dedicated poker and games platforms.",
    ],
    providers: ["Evolution", "Playtech", "NetEnt", "Pragmatic Play"],
    verdict:
      "Bet365 remains the most complete betting product available. If you value depth of markets, streaming and reliability over flashy bonuses, it is very hard to beat. A comfortable second on our list.",
  },
  {
    rank: 3,
    slug: "betmgm",
    name: "BetMGM Casino",
    rating: 4.7,
    logo: "https://casinopick.online/__l5e/assets-v1/57a6f41d-089e-4b36-b17b-5bc30e2d6e3b/betmgm.jpg",
    playUrl: "https://casino.betmgm.com/",
    kind: "Casino & sportsbook",
    offer:
      "Deposit match plus bonus play for new players; terms differ by state and by market",
    intro:
      "BetMGM leans on the MGM Resorts brand and delivers a polished casino-first experience with a growing sportsbook alongside it. The rewards programme tied to MGM properties is a genuine differentiator for regular players.",
    quickFacts: [
      { label: "Founded", value: "2018" },
      { label: "Available regions", value: "Multiple US states and international markets" },
      { label: "Minimum redemption", value: "Withdrawals vary by state and method" },
      { label: "Game providers", value: "15+ studios" },
    ],
    overview: [
      "BetMGM is primarily a casino brand with a strong slots and live dealer catalogue, backed by a well-integrated sportsbook.",
      "The standout feature is MGM Rewards: play online and earn tier credits that carry over to MGM's physical resorts and hotels.",
      "Availability and exact offers change by jurisdiction, so the welcome deal you see depends on where you are.",
    ],
    pros: [
      "Large casino catalogue with strong live dealer selection",
      "MGM Rewards links online play to resort benefits",
      "Polished, easy-to-navigate app",
      "Frequent casino promotions and tournaments",
      "Well-capitalised, trusted operator",
      "Exclusive in-house branded games",
    ],
    cons: [
      "Offers and availability differ significantly by state",
      "Sportsbook depth trails the dedicated books",
      "Wagering requirements apply to bonus play",
      "Rewards value is best for those near MGM properties",
    ],
    keyFacts: [
      { label: "Launch year", value: "2018" },
      { label: "Availability", value: "Regulated US states and select markets; 21+ in most states" },
      { label: "Minimum purchase", value: "Varies by state, typically $10" },
      { label: "Redemption", value: "Withdrawals vary by state and method" },
      { label: "Payment methods", value: "Debit card, PayPal, online banking, PayNearMe" },
      { label: "Mobile", value: "Native iOS and Android apps" },
      { label: "Customer support", value: "Live chat and email" },
      { label: "Crypto support", value: "Not supported" },
    ],
    games: [
      "Hundreds of slots including exclusive MGM-branded titles.",
      "Live dealer roulette, blackjack and baccarat.",
      "RNG table games and video poker.",
      "Integrated sportsbook across major US and global sports.",
    ],
    providers: ["Evolution", "NetEnt", "IGT", "Pragmatic Play"],
    verdict:
      "BetMGM is the pick for casino players who want a polished app and rewards that reach beyond the screen. The MGM Rewards tie-in is unmatched. It earns a strong third place.",
  },
  {
    rank: 4,
    slug: "paddy-power",
    name: "Paddy Power",
    rating: 4.6,
    logo: "https://casinopick.online/__l5e/assets-v1/b6f8394e-344f-42b2-b6af-8755f3a4a22e/paddy-power.gif",
    playUrl: "https://www.paddypower.com/",
    kind: "Sportsbook & casino",
    offer:
      "New customer bet-and-get offer — current amount and qualifying stake on site",
    intro:
      "Paddy Power is one of the best-known betting brands in the UK and Ireland, famous for its marketing but backed by a genuinely strong sportsbook. Horse racing is a particular strength given the brand's Irish roots.",
    quickFacts: [
      { label: "Founded", value: "1988" },
      { label: "Available regions", value: "United Kingdom and Ireland" },
      { label: "Minimum redemption", value: "Withdrawals from £10 after verification" },
      { label: "Game providers", value: "15+ studios" },
    ],
    overview: [
      "Paddy Power offers a full sportsbook plus casino, games and bingo under one account.",
      "Horse racing coverage is excellent, with money-back specials and enhanced places on big meetings a regular feature.",
      "The brand's personality is on full show throughout the product, which some love and others find noisy.",
    ],
    pros: [
      "Excellent horse racing coverage and regular racing specials",
      "Frequent money-back and price-boost promotions",
      "Well-designed app with strong bet builder",
      "Established, trusted operator in UK and Ireland",
      "Good range of casino and live dealer games",
      "Reliable cash-out across most markets",
    ],
    cons: [
      "Heavy branding can feel busy",
      "Promotions carry qualifying conditions worth reading",
      "Winning accounts may see stake restrictions",
      "Streaming library is smaller than the market leader",
    ],
    keyFacts: [
      { label: "Launch year", value: "1988" },
      { label: "Availability", value: "United Kingdom and Ireland; 18+ only" },
      { label: "Minimum purchase", value: "Minimum deposit typically £10" },
      { label: "Redemption", value: "Withdrawals from £10 after verification" },
      { label: "Payment methods", value: "Debit card, PayPal, Apple Pay, bank transfer" },
      { label: "Mobile", value: "Native iOS and Android apps plus mobile web" },
      { label: "Customer support", value: "Live chat and email" },
      { label: "Crypto support", value: "Not supported" },
    ],
    games: [
      "Football, horse racing, greyhounds, Gaelic sports and more.",
      "Regular racing specials, price boosts and bet builder markets.",
      "Casino slots, live dealer tables and jackpot games.",
      "Bingo and dedicated games section.",
    ],
    providers: ["Playtech", "Evolution", "Pragmatic Play", "Red Tiger"],
    verdict:
      "Paddy Power blends a strong sportsbook — especially for racing — with a lively, promotion-heavy approach. If you can look past the branding, the underlying product is excellent. A solid fourth.",
  },
  {
    rank: 5,
    slug: "casumo",
    name: "Casumo",
    rating: 4.4,
    logo: "https://casinopick.online/__l5e/assets-v1/fd0b7e7b-c552-440d-b10b-8a6a471767a9/casumo.jpg",
    playUrl: "https://www.casumo.com/",
    kind: "Casino & sportsbook",
    offer: "First-deposit welcome offer with bonus spins — terms on site",
    intro:
      "Casumo is a casino-first brand that made its name with a gamified, adventure-style experience. It is bright, playful and easy to use, with a solid slots catalogue and a lighter sportsbook attached.",
    quickFacts: [
      { label: "Founded", value: "2012" },
      { label: "Available regions", value: "United Kingdom and select European markets" },
      { label: "Minimum redemption", value: "Withdrawals from £10 after verification" },
      { label: "Game providers", value: "20+ studios" },
    ],
    overview: [
      "Casumo is best known for its casino, wrapped in a gamified reward journey that layers levels and bonuses over normal play.",
      "The slots library is broad and the live dealer selection is solid, powered by leading studios.",
      "The sportsbook is present but secondary — fine for casual bets rather than a serious punter's main book.",
    ],
    pros: [
      "Fun, gamified experience with reward journeys",
      "Broad slots catalogue from leading studios",
      "Clean, colourful and easy-to-use interface",
      "Solid live dealer selection",
      "Fast onboarding and simple deposits",
      "Regular reels and reward promotions",
    ],
    cons: [
      "Sportsbook is lighter than dedicated books",
      "Bonus play carries wagering requirements",
      "Fewer markets for serious sports bettors",
      "Availability limited to certain regions",
    ],
    keyFacts: [
      { label: "Launch year", value: "2012" },
      { label: "Availability", value: "United Kingdom and select Europe; 18+ only" },
      { label: "Minimum purchase", value: "Minimum deposit typically £10" },
      { label: "Redemption", value: "Withdrawals from £10 after verification" },
      { label: "Payment methods", value: "Debit card, PayPal, Trustly, bank transfer" },
      { label: "Mobile", value: "Mobile-first website and apps" },
      { label: "Customer support", value: "Live chat and email" },
      { label: "Crypto support", value: "Not supported" },
    ],
    games: [
      "Hundreds of slots including popular megaways titles.",
      "Live dealer roulette, blackjack and game shows.",
      "RNG table games and jackpots.",
      "A lighter sportsbook covering major sports.",
    ],
    providers: ["NetEnt", "Evolution", "Play'n GO", "Pragmatic Play"],
    verdict:
      "Casumo is a great casino for players who want fun and personality over raw depth. The gamified journey keeps things fresh, though the sportsbook is a side dish rather than the main course. It rounds out our top five.",
  },
];

export const NAV_LINKS = [
  { label: "Top Picks", href: "/#top-picks" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

export const getCasinoBySlug = (slug) => CASINOS.find((c) => c.slug === slug);
